import React from "react";
import { TokenInfo } from "../../hooks/useTokenCount";

interface TokenCounterProps {
  tokenInfo: TokenInfo;
}

export const TokenCounter: React.FC<TokenCounterProps> = ({ tokenInfo }) => {
  const { estimatedTokens, maxTokens, isOverLimit, percentage } = tokenInfo;

  if (estimatedTokens < maxTokens * 0.7) {
    return null; // Don't show until 70% of limit
  }

  return (
    <div className="flex items-center gap-2 text-xs text-[#8E8378]">
      <div className="w-16 h-1.5 bg-[#E5DDD3] rounded-full overflow-hidden">
        <div
          className={`h-full transition-all ${
            isOverLimit ? "bg-[#d6615c]" : "bg-[#2C405F]"
          }`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <span className={isOverLimit ? "text-[#d6615c] font-medium" : ""}>
        {estimatedTokens.toLocaleString()} / {maxTokens.toLocaleString()}
      </span>
    </div>
  );
};
